import React from 'react';
import Image from 'src/components/Common/ImageFluid';
import { DesktopImage, MobileImage, StyledImage } from './styles';

interface Props {
  data: {
    image: any;
    mobileImage: any;
    hasTopMargin: boolean;
  };
  context: {
    _type: string;
  };
}

const ImageModule = ({ data, context }: Props) => {
  const { image, mobileImage, hasTopMargin = true } = data;
  
  return (
    <StyledImage className={context?._type == "collection" && "collection-styled-image"} hasTopMargin={hasTopMargin}>
        <DesktopImage>
            <Image imageRef={image} />
        </DesktopImage>
        <MobileImage>
            <Image imageRef={mobileImage} />
        </MobileImage>
    </StyledImage>
  );
};

export default ImageModule;
